<div class="u-shadow-mini {{ sectionclass }}" style="position: relative;">
	<app-loader [showLoader]="showLoad"></app-loader>

	<div class="c-portlet_box_specs">
		<div
			class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap"
		>
			<div class="o-stack__cell">
				<h5>{{ sectiontitle }}</h5>
				<span *ngIf="hasData">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon"
						(click)="downloadCSV()"
						target="_blank"
						*ngIf="downloadConfiguration && downloadConfiguration.enableDownload"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</a>
				</span>
			</div>
		</div>
		<div class="analytics-portlet-content">
			<div class="o-stack o-stack--nowrap o-stack--center" *ngIf="hasData">
				<div class="social-demographic-gender-list-cntr" *ngIf="demographicData">
					<ul class="gender-div">
						<li
							*ngFor="let gender of objectKeys(demographicData).sort(); let index = index"
							class="social-demographic-gender-list-item"
							[ngClass]="{ activeGender: activeIndex === index }"
							(click)="setGenderData(gender, index)"
						>
							{{ gender.charAt(0).toUpperCase() + gender.substr(1).toLowerCase() }}
						</li>
					</ul>
				</div>
				<div *ngIf="chartArrData[selectedGender]" class="chart-div">
					<div
						*ngFor="let ageGroup of objectKeys(chartArrData[selectedGender]).sort(); let index = index"
						class="donut-carousel-container"
					>
						<div class="donut-container-elem">
							<app-donut
								[chartData]="chartArrData[selectedGender][ageGroup]"
								[chartConfigurationObj]="chartConfigObj"
								hasProfileImg="true"
							></app-donut>
						</div>
						<div class="gender-donut-label">
							<b>{{ selectedGender | uppercase }} | {{ ageGroup }}</b>
						</div>
						<!-- <div class="gender-icon">
              <img src="assets/images/profile.png" />
            </div> -->
					</div>
					<div class="legend-div">
						<div (click)="updateChartData('impressions')" class="label-container">
							<div class="labels" [ngClass]="{ 'primary-color-bg': impressionsState }"></div>
							<span class="label-text">Impressions</span>
						</div>
						<div (click)="updateChartData('clicks')" class="label-container">
							<div class="labels" [ngClass]="{ 'secondary-color-bg': clickState }"></div>
							<span class="label-text">Clicks</span>
						</div>
					</div>
				</div>
			</div>
			<div class="map-no-data" *ngIf="!hasData">No Data to Display</div>
		</div>
	</div>
</div>
